// extracted by mini-css-extract-plugin
module.exports = {"copyright":"Copyright_copyright__oOc48","company":"Copyright_company__g2zdo","imgWrapper":"Copyright_imgWrapper__aF96R","link":"Copyright_link__KMFPh"};